import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { PortalLayoutModule } from './ui/pages/common/layout/portal-layout.module';
import { PortalExceptionHandlingModule } from './exception/exception-handling.module';

@NgModule({
  imports: [
    HttpClientModule,
    PortalExceptionHandlingModule,
    RouterModule,
    PortalLayoutModule,
  ],
  exports: [
    RouterModule,
  ]
})
export class PortalModule {
}
